var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._v(" "+_vm._s(_vm.macAddress)+" "),_c('transition',{attrs:{"name":"el-fade-in-linear"}},[_c('IndexPage')],1),_c('div',{staticClass:"main"},[_c('transition',{attrs:{"name":"el-fade-in","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }